import {
    BookingflowStateMachine,
    GeneralActions,
} from '@raskrask-dk/bookingflow-state-machine'
import { t } from 'i18next'
import { Dispatch, SetStateAction, useEffect } from 'react'
import { ErrorCase } from '../../redux/reducers/appSettings'
import { ErrorPageButtonTypes } from './error.props'

export const useDetermineErrorPageContent = (
    setButtontype: Dispatch<SetStateAction<ErrorPageButtonTypes>>,
    setPrimaryTextBlock: Dispatch<SetStateAction<string>>,
    BFSM: BookingflowStateMachine,
    errorCase: ErrorCase
): void => {
    useEffect(() => {
        const determineContent = (): void => {
            switch (errorCase) {
                case 'MoveBookNoAvailabilities': {
                    setButtontype('Rebook')
                    setPrimaryTextBlock(
                        t('errorpage.textblock.movebook.noavailabilities')
                    )
                    break
                }
                case 'MoveBookBadData': {
                    setButtontype('Rebook')
                    setPrimaryTextBlock(
                        'errorpage.textblock.basistypes.loaderror'
                    )
                    break
                }
                case 'RebookBadData': {
                    setButtontype('RestartFlow')
                    setPrimaryTextBlock(
                        t('errorpage.textblock.rebook.dataerror')
                    )
                    break
                }
                case 'BasisTypesLoadError': {
                    setButtontype('RestartFlow')
                    setPrimaryTextBlock(t('errorpage.textblock.unknownerror'))
                    break
                }
                case 'LoadCalendarError': {
                    setButtontype('RestartFlow')
                    setPrimaryTextBlock(t('errorpage.textblock.unknownerror'))
                    break
                }

                case 'GetPaymentInfoError': {
                    setButtontype('RestartFlow')
                    setPrimaryTextBlock(t('errorpage.textblock.unknownerror'))
                    break
                }
                case 'FinalizeError': {
                    setButtontype('RestartFlow')
                    setPrimaryTextBlock(t('errorpage.textblock.finalizeerror'))
                    break
                }
                case 'MoveBookFinalizeError': {
                    setButtontype('NoButton')
                    setPrimaryTextBlock(
                        t('movebooking.error.unknownerror.text')
                    )
                    break
                }
                case 'MoveBookInPast': {
                    setButtontype('Rebook')
                    setPrimaryTextBlock(t('movebooking.error.inthepast.text'))
                    break
                }
                case 'MoveBookWithin24Hours': {
                    setButtontype('Rebook')
                    setPrimaryTextBlock(
                        t('movebooking.error.within24hours.text')
                    )
                    break
                }
                case 'MoveBookCancelled': {
                    setButtontype('Rebook')
                    setPrimaryTextBlock(t('movebooking.error.cancelled.text'))
                    break
                }
                case 'OverlappingError': {
                    setButtontype('GoToCalendar')
                    setPrimaryTextBlock(t('finalize.error.overlap.text'))
                    break
                }
                // SPECIAL CASE! Here we initiate the NoAvailable State
                case 'NoPartnersAvailable': {
                    BFSM.doAction(GeneralActions.ChooseNoAvailable, undefined)
                    break
                }
                case 'CancelBookAlreadyCancelled': {
                    setButtontype('RestartFlow')
                    setPrimaryTextBlock(
                        t('cancelbook.errormessage.alreadycancelled')
                    )
                    break
                }
                case 'CancelBookingInThePast': {
                    setButtontype('RestartFlow')
                    setPrimaryTextBlock(t('cancelbook.errormessage.inthepast'))
                    break
                }
                default:
                    setButtontype('RestartFlow')
                    setPrimaryTextBlock(t('errorpage.textblock.unknownerror'))
            }
        }
        determineContent()
    }, [errorCase])
}
